import React from 'react';
import PropTypes from 'prop-types';

import { withTheme } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconFile = ({ theme, ...otherProps }) => (
  <SvgIcon {...otherProps} viewBox="0 0 58 68">
    <g transform="translate(-6, -2)">
      <g transform="translate(10, 2)">
        <path fill={theme.palette.primary.A100} d="m5 0h28l21 21v42c0 2.7614-2.2386 5-5 5h-44c-2.7614 0-5-2.239-5-5v-58c0-2.7614 2.2386-5 5-5z" />
        <path fill={theme.palette.primary.A400} d="m52.025 19.072h-18.025l20 20v-18.025l-1.9746-1.9746z" />
        <path fill={theme.palette.grey[100]} d="m33 0 21 21h-16c-2.7614 0-5-2.2386-5-5v-16z" />
        <path fill={theme.palette.primary.A400} d="m35 40 16 16h-16v-16zm-34.991 20-4.009-4h16v4h-11.991zm11.991-4h39v4h-39v-4z" />
      </g>
      <rect fill={theme.palette.grey[100]} height="16" width="39" y="42" x="6" />
    </g>
  </SvgIcon>
);

IconFile.propTypes = {
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      primary: PropTypes.shape({
        A100: PropTypes.string.isRequired,
        A400: PropTypes.string.isRequired,
      }).isRequired,
      grey: PropTypes.shape({
        100: PropTypes.string.isRequired,
      }).isRequired,
      common: PropTypes.shape({
        white: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

export default withTheme()(IconFile);



// WEBPACK FOOTER //
// ./src/components/icons/IconFile.js